var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import DrawerHeader from 'syf-component-library/ui/atoms/DrawerHeader';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { useActivityContext } from '../../../context/activity-store';
import hooks from '../../../hooks';
import { StyledBorder } from '../../../styles/common';
export var CardHeader = function (_a) {
    var account = _a.account, config = _a.config;
    var accountId = useActivityContext().accountId;
    var headerProps = hooks.useCardHeaderValues(account !== null && account !== void 0 ? account : accountId, config);
    if (!headerProps) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Inset, { children: _jsx(DrawerHeader, __assign({}, headerProps)) }), _jsx(StyledBorder, {})] }));
};
//# sourceMappingURL=index.js.map